import { default as JsonViewLib } from '@uiw/react-json-view'
import { githubLightTheme } from '@uiw/react-json-view/githubLight'

export const JsonView = ({ data }: { data: object }) => {
  const customStyle = { ...githubLightTheme, '--w-rjv-background-color': 'transparent' }

  const handleCopy = (text: string, _value?: object) => {
    // Remove leading and trailing quotes if present
    const trimmedText = text.replace(/^"(.*)"$/, '$1')

    // Use setTimeout to ensure this runs after the library's copy
    setTimeout(() => {
      navigator.clipboard.writeText(trimmedText)
    }, 0)
  }

  return (
    <JsonViewLib
      value={data}
      style={customStyle}
      displayDataTypes={false}
      shortenTextAfterLength={0}
      displayObjectSize={false}
      onCopied={handleCopy}>
      <JsonViewLib.Colon
        render={({ children, ...props }, { parentValue }) => {
          if (Array.isArray(parentValue) && children === ':') {
            return <span />
          }
          const renderProps = { ...props, children }
          return <span {...renderProps} />
        }}
      />
      <JsonViewLib.KeyName
        render={({ children, ...props }, { parentValue }) => {
          if (Array.isArray(parentValue) && Number.isFinite(children)) {
            return <span />
          }
          return <span {...props}>{children}</span>
        }}
      />
      <JsonViewLib.Null
        render={() => {
          return <span>null</span>
        }}
      />
    </JsonViewLib>
  )
}
